/**
 *  routes/index.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import Dashboard from "../layouts/Dashboard/Dashboard.jsx";
import Login from "../layouts/Account/Login.jsx";
import { Policies } from "../views/Policies/index.jsx";

var indexRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/home",
    name: "Monitoramento",
    component: Dashboard,
  },
  {
    path: "/users",
    name: "Usuários",
    component: Dashboard,
  },
  {
    path: "/virtual-fence",
    name: "Cerca Virtual",
    component: Dashboard,
  },
  {
    path: "/danger-zone",
    name: "Área Sinistro",
    component: Dashboard,
  },
  {
    path: "/alerts",
    name: "Avisos",
    component: Dashboard,
  },
  {
    path: "/burned-reports",
    name: "Queimadas",
    component: Dashboard,
  },
  {
    path: "/deforestation-reports",
    name: "Desmatamentos",
    component: Dashboard,
  },
  {
    path: "/notifications",
    name: "Enviar Notificações",
    component: Dashboard,
  },
  {
    path: "/videos",
    name: "Videos",
    component: Dashboard,
  },
  {
    path: "/follow",
    name: "Acompanhar",
    component: Dashboard,
  },
  {
    redirect: true,
    path: "/",
    to: "/login",
    name: "Dashboard",
  },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx